/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface Place
 */
export interface Place {
    /**
     * 
     * @type {string}
     * @memberof Place
     */
    googlePlaceId: string;
    /**
     * 
     * @type {string}
     * @memberof Place
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Place
     */
    address: string;
    /**
     * 
     * @type {Location}
     * @memberof Place
     */
    location: Location;
}

/**
 * Check if a given object implements the Place interface.
 */
export function instanceOfPlace(value: object): value is Place {
    if (!('googlePlaceId' in value) || value['googlePlaceId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function PlaceFromJSON(json: any): Place {
    return PlaceFromJSONTyped(json, false);
}

export function PlaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Place {
    if (json == null) {
        return json;
    }
    return {
        
        'googlePlaceId': json['googlePlaceId'],
        'name': json['name'],
        'address': json['address'],
        'location': LocationFromJSON(json['location']),
    };
}

export function PlaceToJSON(json: any): Place {
    return PlaceToJSONTyped(json, false);
}

export function PlaceToJSONTyped(value?: Place | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'googlePlaceId': value['googlePlaceId'],
        'name': value['name'],
        'address': value['address'],
        'location': LocationToJSON(value['location']),
    };
}

